export const languages = ["de", "en"]
